import { saveAs } from 'file-saver';
import { getInstance } from '../index';
import { downloadFile, apiBaseUrl } from '../../utilities/api/apiHelper';

class Quote {
  constructor() {
    this.axios = getInstance();
  }

  async getQuotePrice(applicationId) {
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/application/${applicationId}/quotePrice`,
      {}
    );
  }

  async openQuoteDocument(url) {
    return downloadFile(this.axios, url, saveAs);
  }
}

export const getQuoteDocumentLink = (applicationId) => {
  return `${apiBaseUrl}/backendforfrontend/application/${applicationId}/document/quote`;
};

export const getInterviewQuoteDocumentLink = (
  applicationId,
  interviewId,
  interviewToken,
  adviserId
) => {
  let url = `${apiBaseUrl}/document/interview/${interviewId}/${interviewToken}/quote?fileName=${applicationId}-quote&alreadyExists=true`;
  url = !adviserId ? url : `${url}&adviserId=${adviserId}`;
  return url;
};

const quote = new Quote(getInstance());
export default quote;
